import React from "react";
import { TextStyle, View, ViewStyle } from "react-native";
import { tposButtonStyles as styles } from "./styles";
import { TouchableOpacity } from ".";
import { Text } from "../Text";

type TposButtonProps = {
  onPress: () => void;
  children: JSX.Element;
  disabled?: boolean;
  buttonText: string;
  styles?: {
    buttonContainer?: ViewStyle;
    disabledContainer?: ViewStyle;
    buttonText?: TextStyle;
  };
  accessibilityLabel?: string;
  accessibilityHint?: string;
  testID?: string;
};

const TposButton = (props: TposButtonProps): JSX.Element => {
  const {
    children,
    buttonText,
    disabled = false,
    onPress,
    styles: customStyles = {
      buttonContainer: null,
      disabledContainer: null,
      buttonText: null,
    },
    accessibilityLabel,
    accessibilityHint,
    testID,
  } = props;

  const buttonContainer = [
    styles.buttonContainer,
    customStyles ? { ...customStyles.buttonContainer } : undefined,
  ];
  const disabledContainer = [
    styles.disabledContainer,
    customStyles ? { ...customStyles.disabledContainer } : undefined,
  ];
  const buttonTextStyle = [
    styles.buttonText,
    customStyles ? { ...customStyles.buttonText } : {},
  ];
  return (
    <TouchableOpacity
      style={disabled ? disabledContainer : buttonContainer}
      disabled={disabled}
      onPress={onPress}
      accessibilityRole="button"
      accessibilityLabel={accessibilityLabel || buttonText}
      accessibilityHint={accessibilityHint}
      accessibilityState={{ disabled }}
      testID={testID}
    >
      <View style={styles.container}>
        {children && <View style={styles.iconContainer}>{children}</View>}
        <Text style={buttonTextStyle}>{buttonText}</Text>
      </View>
    </TouchableOpacity>
  );
};

export default TposButton;
